import { render, staticRenderFns } from "./SaleBadge.vue?vue&type=template&id=4d7a18a6&scoped=true"
import script from "./SaleBadge.vue?vue&type=script&lang=js"
export * from "./SaleBadge.vue?vue&type=script&lang=js"
import style0 from "./SaleBadge.vue?vue&type=style&index=0&id=4d7a18a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7a18a6",
  null
  
)

export default component.exports